import axios from "axios"
import { services } from "../../../../../../config/api"
import { Dispatch } from "redux"
import { ActionType } from "./ActionTypes"

function fetchServices() {
    return axios.get(services)
}

export const actionFetchServices = () => {

    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.SERVICE_LOADING })
        fetchServices().then((res) => {
            dispatch({ type: ActionType.SERVICE_DATA, list: res.data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.SERVICE_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.SERVICE_ERROR, message: err.response.data.error })
            }
        })
    }
}
